(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topg-product-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const target=event.target;
  if(!(target instanceof Element))return;
  const button=target.closest('.topg-spec-toggle');
  if(!button)return;
  const panelId=button.getAttribute('aria-controls');
  const panel=panelId?document.getElementById(panelId):null;
  if(!panel)return;
  const isExpanded=button.getAttribute('aria-expanded')==='true';
  panel.hidden=isExpanded;
  button.setAttribute('aria-expanded',isExpanded?'false':'true');
});

  } catch(e) { console.error(e); }
})();
})();
